import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchMe, memberLogin, memberRegister } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("aw_token");
    if (!token) { setUser(false); setReady(true); return; }
    try {
      const me = await fetchMe();
      setUser(me);
    } catch {
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const res = await memberLogin({ email, password });
    localStorage.setItem("aw_token", res.token);
    setUser(res.user || { email: res.email, name: res.name });
    return res;
  };
  const register = async (email, password, name) => {
    const res = await memberRegister({ email, password, name });
    localStorage.setItem("aw_token", res.token);
    setUser(res.user);
    return res;
  };
  const logout = () => { localStorage.removeItem("aw_token"); setUser(false); };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
